module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-reviews-content"
  }, [_c('div', {
    staticClass: "custom-reviews-content__container"
  }, [(_vm.location == "unknown") ? _c('div', {
    staticClass: "custom-reviews-content__location"
  }, [_c('h2', {
    staticClass: "custom-reviews-content__location-header"
  }, [_vm._v("Let Us Know What You Think!")]), _c('br'), _c('div', {
    staticClass: "custom-reviews-content__location-title"
  }, [_vm._v("Choose Your Location")]), _c('a', {
    staticClass: "custom-reviews-content__location-button",
    style: ({
      'background': '#3FD5AF'
    }),
    on: {
      "click": function($event) {
        _vm.isLocation("las")
      }
    }
  }, [_vm._v("Las Vegas Orthodontics - Eastern")]), _c('a', {
    staticClass: "custom-reviews-content__location-button",
    style: ({
      'background': '#3E8EDE'
    }),
    on: {
      "click": function($event) {
        _vm.isLocation("chen")
      }
    }
  }, [_vm._v("Las Vegas Orthodontics - Summerlin")])]) : _vm._e(), (_vm.location == "las") ? _c('div', {
    staticClass: "custom-reviews-content__location-wrap"
  }, [(_vm.yelper == "unknown") ? _c('div', {
    staticClass: "custom-reviews-content__yelper-buttons"
  }, [_c('img', {
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/yelp-logo.png",
      "alt": "yelp-logo"
    }
  }), _c('h1', [_vm._v("Are you a Yelper?")]), _c('a', {
    staticClass: "custom-reviews-content__yelper-button",
    style: ({
      'background': '#3FD5AF'
    }),
    on: {
      "click": function($event) {
        _vm.isYelper("yes")
      }
    }
  }, [_vm._v("YES")]), _c('a', {
    staticClass: "custom-reviews-content__yelper-button",
    style: ({
      'background': '#3E8EDE'
    }),
    on: {
      "click": function($event) {
        _vm.isYelper("no")
      }
    }
  }, [_vm._v("NO")])]) : _vm._e(), (_vm.yelper == "yes") ? _c('a', {
    staticClass: "custom-reviews-content__button",
    style: ({
      'background': '#a0251e'
    }),
    attrs: {
      "href": "https://www.yelp.com/biz/las-vegas-orthodontics-las-vegas-2",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-reviews-content__social-icon",
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/yelp-square.png"
    }
  }), _c('div', {
    staticClass: "custom-reviews-content__text"
  }, [_vm._v("Review us on Yelp")])]) : _vm._e(), (_vm.yelper == "no") ? _c('a', {
    staticClass: "custom-reviews-content__button",
    style: ({
      'background': '#2d417a'
    }),
    attrs: {
      "href": "https://www.facebook.com/lasvegasortho",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-reviews-content__social-icon",
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/fb_icon.png"
    }
  }), _c('div', {
    staticClass: "custom-reviews-content__text"
  }, [_vm._v("Review us on Facebook")])]) : _vm._e(), (_vm.yelper == "no") ? _c('a', {
    staticClass: "custom-reviews-content__button",
    style: ({
      'background': '#e5a30e'
    }),
    attrs: {
      "href": "https://www.google.com/search?q=las+vegas+orthodontics&client=safari&rls=en&ei=ffnrY6yPHuL1kPIP8OeoaA&ved=0ahUKEwjswaz99pX9AhXiOkQIHfAzCg0Q4dUDCBA&uact=5&oq=las+vegas+orthodontics&gs_lcp=Cgxnd3Mtd2l6LXNlcnAQAzILCC4QgAQQxwEQrwEyBQgAEIAEMgUIABCABDIJCAAQFhAeEPEEMgkIABAWEB4Q8QQyCQgAEBYQHhDxBDIJCAAQFhAeEPEEMgkIABAWEB4Q8QQyCQgAEBYQHhDxBDIICAAQFhAeEA86CggAEEcQ1gQQsAM6DQgAEEcQ1gQQyQMQsAM6CAgAEJIDELADOgUIABCRAjoLCC4QxwEQrwEQkQI6CwgAEIAEELEDEIMBOgsILhCABBCxAxCDAToRCC4QgAQQsQMQgwEQxwEQ0QM6DgguEIAEELEDEMcBENEDOggILhCABBDUAjoICAAQgAQQsQM6CwguEIAEEMcBENEDOgQIABBDOgcILhCxAxBDOg4ILhCvARDHARCxAxCABDoFCC4QgAQ6CAguEIAEELEDOhAIABCABBCxAxCDARBGEIACOg4ILhCABBCxAxDHARCvAToSCAAQgAQQsQMQgwEQChBGEIACOg0IABCABBCxAxCDARAKOgoILhCABBCxAxAKOhAILhCABBCxAxDHARCvARAKOg0ILhCABBCxAxCDARAKOgoIABCABBCxAxAKOg0ILhCABBDHARCvARAKOgYIABAWEB5KBAhBGABKBAhGGABQuAtYwh5gox9oA3ABeACAAX6IAawPkgEEMTkuM5gBAKABAcgBCsABAQ&sclient=gws-wiz-serp#lrd=0x80c8c51f4405efe3:0xb9cb31397a77f9ea,3,,,,",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-reviews-content__social-icon",
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/new-google-favicon-512.png"
    }
  }), _c('div', {
    staticClass: "custom-reviews-content__text"
  }, [_vm._v("Review us on Google")])]) : _vm._e()]) : _vm._e(), (_vm.location == "chen") ? _c('div', {
    staticClass: "custom-reviews-content__location-wrap"
  }, [(_vm.yelper == "unknown") ? _c('div', {
    staticClass: "custom-reviews-content__yelper-buttons"
  }, [_c('img', {
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/yelp-logo.png",
      "alt": "yelp-logo"
    }
  }), _c('h1', [_vm._v("Are you a Yelper?")]), _c('a', {
    staticClass: "custom-reviews-content__yelper-button",
    style: ({
      'background': '#3FD5AF'
    }),
    on: {
      "click": function($event) {
        _vm.isYelper("yes")
      }
    }
  }, [_vm._v("YES")]), _c('a', {
    staticClass: "custom-reviews-content__yelper-button",
    style: ({
      'background': '#3E8EDE'
    }),
    on: {
      "click": function($event) {
        _vm.isYelper("no")
      }
    }
  }, [_vm._v("NO")])]) : _vm._e(), (_vm.yelper == "yes") ? _c('a', {
    staticClass: "custom-reviews-content__button",
    style: ({
      'background': '#a0251e'
    }),
    attrs: {
      "href": "https://www.yelp.com/biz/welch-orthodontics-las-vegas",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-reviews-content__social-icon",
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/yelp-square.png"
    }
  }), _c('div', {
    staticClass: "custom-reviews-content__text"
  }, [_vm._v("Review us on Yelp")])]) : _vm._e(), (_vm.yelper == "no") ? _c('a', {
    staticClass: "custom-reviews-content__button",
    style: ({
      'background': '#2d417a'
    }),
    attrs: {
      "href": "https://www.facebook.com/welchorthodontic",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-reviews-content__social-icon",
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/fb_icon.png"
    }
  }), _c('div', {
    staticClass: "custom-reviews-content__text"
  }, [_vm._v("Review us on Facebook")])]) : _vm._e(), (_vm.yelper == "no") ? _c('a', {
    staticClass: "custom-reviews-content__button",
    style: ({
      'background': '#e5a30e'
    }),
    attrs: {
      "href": "https://www.google.com/search?q=welch+orthodontics+vegas&client=safari&rls=en&ei=TZ3uY87TCM3N0PEPzp6UuAQ&ved=0ahUKEwiOrum9-5r9AhXNJjQIHU4PBUcQ4dUDCBA&uact=5&oq=welch+orthodontics+vegas&gs_lcp=Cgxnd3Mtd2l6LXNlcnAQAzIJCAAQFhAeEPEEMgUIABCGAzIFCAAQhgMyBQgAEIYDMgUIABCGAzIFCAAQhgM6CggAEEcQ1gQQsAM6DQgAEEcQ1gQQyQMQsAM6CAgAEJIDELADSgQIQRgAUJAFWO8TYL0VaAFwAXgAgAFmiAG3BJIBAzQuMpgBAKABAcgBBsABAQ&sclient=gws-wiz-serp#lrd=0x80c8c000598318d1:0x13f7377ad29c56da,3,,,,",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-reviews-content__social-icon",
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/new-google-favicon-512.png"
    }
  }), _c('div', {
    staticClass: "custom-reviews-content__text"
  }, [_vm._v("Review us on Google ")])]) : _vm._e()]) : _vm._e()]), (_vm.location == "chen" || _vm.location == "las") ? _c('h5', {
    staticClass: "center custom-reviews-content__heading"
  }, [_vm._v(" If you have not written more than 10 reviews on Yelp, please click “No” to submit a Google or Facebook review.       ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b61f456","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-reviews-content/custom-reviews-content.pug
// module id = 603
// module chunks = 1